import { attribute as attributeIcon, rightMini } from "assets/icons";
import styled from "@emotion/styled";
import { Col, Modal, Typography } from "antd";
import { FC, useState } from "react";
//import ProductAttributeTable from "./ProductAttributeTabel";
import { useMasterProperty } from "hooks/useMasterData";
import ProductAttributeSelect from "./ProductAttributeSelect";
import { AttributeInput } from "services/interface";

interface ProductAtributteCardProps {
  attribute: AttributeInput[];
  setAttribute: (value: AttributeInput[]) => void;
}


const ProductAtributteCard: FC<ProductAtributteCardProps> = ({
  attribute,
  setAttribute,
}) => {
  const [open, setOpen] = useState(false);

  const { data, isLoading } =  useMasterProperty();

  const handleFinish = (value: AttributeInput[]) => {
    setAttribute(value);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };


  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
      <WrapperAll onClick={showDrawer} >
        <SpanIcon>{attributeIcon}</SpanIcon>
        <TextWrapper>
          <Typography.Text>คุณลักษณะสินค้า</Typography.Text>
        </TextWrapper>
        <RightWrapper>
          <Typography.Text style={{ color: attribute?.length > 0 ? "#2777c8"  :"#C4C4C4" }}>
             { attribute?.length > 0 ? "ตั้งค่าแล้ว": "ไม่ได้ตั้งค่า" } 
          </Typography.Text>
          <IconWrapper onClick={showDrawer}>{rightMini}</IconWrapper>
        </RightWrapper>
      </WrapperAll>
      <Modal
        title="คุณลักษณะสินค้า"
        open={open}
        maskClosable={false}
        footer={null}
        onCancel={onClose}
        width={1000}
        style={{ top: 20 }}
      >
        <DrawerBody>
          <ProductAttributeSelect attributes={attribute}  data={data?.labels || []} loading={isLoading} handleFinish={handleFinish} onClose={onClose} />
        </DrawerBody>
      </Modal>
    </Col>
  );
};

export default ProductAtributteCard;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
  margin-right: 10px;
`;

const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 76px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;

const TextWrapper = styled.div`
  width: 250px;
  height: 100%;
  background-color: #ffffff;
  padding: 27px 20px 0px 20px;
`;

const DrawerBody = styled.div`
  width: 100%;
  height: 100%;
  display: block;
`;
